/*@flow*/
import L from 'leaflet';
import same from 'lib/same';
import pick from 'ramda/src/pick';
import { attach, detach } from './events';
import focusHack from './focusHack';

L.Icon.Default.imagePath = `https://cdnjs.cloudflare.com/ajax/libs/leaflet/${
  L.version
}/images/`;

let defaults = {
  minZoom: 5,
  maxZoom: 22,
  zoomControl: false,
  scrollWheelZoom: true,
  tap: true,
  crs: L.CRS.EPSG3857,
};

export type OptionsT = {|
  center: number[],
  zoom: number,
  zoomPanOptions: ?Object,
  on?: Object,
  ready?: Function,

  minZoom?: number,
  maxZoom?: number,
  zoomControl?: boolean,
  scrollWheelZoom?: boolean,
  tap?: boolean,
  crs?: any,
|};

export default class Schema {
  prevOptions: OptionsT;
  options: OptionsT;
  owner: ?Leaflet$Map;

  constructor(options: $Shape<OptionsT> = {}) {
    this.options = { ...defaults, ...options };
  }

  create(node: HTMLElement): any {
    const m = L.map(node, this.options);
    // attributionHack
    m.removeControl(m.attributionControl);
    const { on, ready } = this.options;
    // Attach event handlers
    on && attach(on, m);
    // Implement the `focusHack`.
    focusHack(m);
    // Trigger ready callback
    if (typeof ready === 'function') {
      ready({ map: m });
      m.invalidateSize();
    }

    this.owner = m;
    return this.owner;
  }

  update(options: OptionsT) {
    this.prevOptions = this.options;
    this.options = options;

    // Re-attach the events.
    this.prevOptions.on && detach(this.prevOptions.on, this.owner);
    this.options.on && attach(this.options.on, this.owner);

    if (!this.owner) return;
    this.setView();
  }

  remove() {
    const { on } = this.options;
    on && detach(on, this.owner);
  }

  setView() {
    const picker = pick(['zoomPanOptions', 'center', 'zoom']);
    const a = picker(this.options);
    const b = picker(this.prevOptions);

    if (same(a, b)) return;
    if (!this.owner) return;
    const { zoomPanOptions = {}, center, zoom } = this.options;
    this.owner.setView(center, zoom, zoomPanOptions);
  }
}
